// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TempComponent_mainContainer__3v46z","imgContainer":"TempComponent_imgContainer__3TGq1","fig":"TempComponent_fig__Kw_r2","white":"TempComponent_white__20Tpt"};